import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Customer_List_Interface } from 'src/app/Interface/Customer_List_Interface';
import { User_Interface } from 'src/app/Interface/User_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RepresentativeService {

constructor(private http:HttpClient) { }

GetRecord(Token:String):Observable<Array<Customer_List_Interface>>{
  return this.http.get(environment.BaseUrl+ "Daro/Representative?token="+Token).pipe(
    map(data=>{
      return data as Array<Customer_List_Interface>
    })
  )
}

GetSingle(Token:String,id:number):Observable<User_Interface>{
  return this.http.get(environment.BaseUrl+ "Daro/Representative/GetSingle?token="+Token+"&id="+id).pipe(
    map(data=>{
      return data as User_Interface
    })
  )
}

GetSubusername(Token:String):Observable<any>{
  return this.http.get(environment.BaseUrl+ "Daro/Representative/GetSubusername?token="+Token).pipe(
    map(data=>{
      return data as any
    })
  )
}

DeleteRepresentative(id:number,Token:String):Observable<User_Interface>{

  return this.http.get(environment.BaseUrl + "Daro/Representative/Delete?id="+id+"&token="+Token).pipe(
    map(data=>{
      return data as User_Interface
    })
  )

}

AddUser(model: User_Interface,Token:String,ListMenu:Array<number>):Observable<User_Interface>{
  const headers = new HttpHeaders().set('content-type', 'application/json');


  var modelCustomer = {
    id:model.id,
    username:model.username,
    password:model.password,
    type:model.type,
    create_ip:Token,
    fname:model.fname,
    lname:model.lname,
    phone:model.phone,
    del:false,
    subdate:null
  }

  var body={
    ListMenu:ListMenu,
    model:modelCustomer,
  }


    return this.http.post(environment.BaseUrl + "Daro/Representative/Add",body,{headers}).pipe(
      map(data=>{
        return data as User_Interface
      })
    )

}


}
